import { z } from "zod";

const envSchema = z.object({
	VITE_SERVER_URL: z.url(),
	VITE_APP_SLUG: z.string().default("lookdat"),
	VITE_APP_NAME: z.string().default("LookDat"),
	VITE_RECAPTCHA_SITE_KEY: z.string().default(""),
	VITE_SITE_URL: z.url().default("https://www.lookdat.com"),
	VITE_CONTACT_EMAIL: z.email().default("stephanie@lookdat.com"),
});

const _env = envSchema.parse(import.meta.env);

export const env = {
	SERVER_URL: _env.VITE_SERVER_URL,
	APP_SLUG: _env.VITE_APP_SLUG,
	APP_NAME: _env.VITE_APP_NAME,
	RECAPTCHA_SITE_KEY: _env.VITE_RECAPTCHA_SITE_KEY,
	SITE_URL: _env.VITE_SITE_URL,
	CONTACT_EMAIL: _env.VITE_CONTACT_EMAIL,
} as const;
